import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import App from './App';
import AuthCallback from './components/AuthCallback';
import AuthProviderWrapper from './components/AuthProviderWrapper';
import { AchievementProvider } from './contexts/AchievementContext';
import { ApplicationTrackerProvider } from './contexts/ApplicationTrackerContext';
import { AuthProvider } from './contexts/AuthContext';
import { GlobalProvider } from './contexts/GlobalContext';
import './styles/tailwind.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <AuthProviderWrapper>
          <GlobalProvider>
            <AchievementProvider>
              <ApplicationTrackerProvider>
                <Router>
                  <Routes>
                    <Route path="/*" element={<App />} />
                    <Route path="/auth/google/callback" element={<AuthCallback />} />
                  </Routes>
                </Router>
              </ApplicationTrackerProvider>
            </AchievementProvider>
          </GlobalProvider>
        </AuthProviderWrapper>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
